import { Link } from "react-router-dom";
import { PANNES } from "../../data/pannes";

/**
 * Lists dedicated /panne/{slug} landing pages relevant for a given appliance.
 * Used on ServicePage and CityServicePage to deep-link into symptom pages.
 *
 * - `applianceKey` : "lave-linge" | "lave-vaisselle" | "frigo" | "four" | "seche-linge"
 * - `cityName` (optional) : appears in the title for city × service pages.
 */
export default function RelatedPannes({ applianceKey, cityName }) {
    const pannes = PANNES.filter((p) => p.appliance === applianceKey);
    if (pannes.length === 0) return null;

    const titleSuffix = cityName ? ` à ${cityName}` : "";

    return (
        <section className="bg-white border-y border-[var(--line)]">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14">
                <div className="divider-amber mb-5" />
                <h2 className="heading text-2xl lg:text-3xl font-extrabold">
                    Diagnostics par symptôme{titleSuffix}
                </h2>
                <p className="mt-3 text-[var(--ink-soft)] max-w-3xl">
                    Cliquez sur votre symptôme pour accéder à la page diagnostic dédiée : causes, premières actions et tarif estimé.
                </p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
                    {pannes.map((p) => (
                        <Link
                            key={p.slug}
                            to={`/panne/${p.slug}`}
                            className="card-soft p-5 block group"
                            data-testid={`related-panne-${p.slug}`}
                        >
                            <div className="flex items-start gap-3">
                                <i className={`${p.icon} text-[var(--amber)] text-lg mt-1`} />
                                <div className="flex-1">
                                    <h3 className="heading text-base font-extrabold text-[var(--navy)] group-hover:text-[var(--amber)] leading-tight">
                                        {p.h1.split("–")[0].trim()}
                                    </h3>
                                    <p className="text-xs text-[var(--ink-soft)] mt-2 line-clamp-2">{p.intro}</p>
                                    <p className="text-xs heading font-bold text-[var(--navy)] mt-3 inline-flex items-center gap-1.5">
                                        Diagnostic complet <i className="fa-solid fa-arrow-right text-[10px]" />
                                    </p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
